import {alpha, Toolbar, Typography} from "@mui/material";
import {BaseModelType} from "../../app/api/types";

interface ExTableToolbarProps<T extends BaseModelType> {
    selection: T[];
    title: string;
    renderActions?: (selection: T[]) => JSX.Element;
}

export default function ExTableToolbar<T extends BaseModelType>(props: ExTableToolbarProps<T>) {
    const {selection, title, renderActions} = props;

    return (
        <Toolbar
            sx={{
                pl: {sm: 2},
                pr: {xs: 1, sm: 1},
                ...(selection.length > 0 && {
                    bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                }),
            }}
        >
            {selection.length > 0 ? (
                <Typography sx={{flex: "1 1 100%"}} color="inherit" variant="subtitle1" component="div">
                    {selection.length} selected
                </Typography>
            ) : (
                <Typography sx={{flex: "1 1 100%"}} variant="h6" id="tableTitle" component="div">
                    {title}
                </Typography>
            )}
            {renderActions && renderActions(selection)}
        </Toolbar>
    );
}
